import { CRMSearch } from 'browser/components/atomic-elements/atoms/select/crm-search/crm-search'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const CRMSearchField = LabelFieldFactory({ InputComponent: CRMSearch })
export { CRMSearchField }
